import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79fd639f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qrcode" }
const _hoisted_2 = { style: {"display":"flex","gap":"16px"} }

import { useApi } from '@/hooks/useApi';
import { JuouProForm, JuouProFormItem, useBaseAsync } from 'juou-managebase-ui';
import { keyBy } from 'lodash';
import { ref } from 'vue';
import QrcodeVue from 'qrcode.vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { convertBase64UrlToImgFile } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'qrcode',
  emits: ["setDownload"],
  setup(__props, { expose: __expose, emit: __emit }) {

const addWeappFormRef = ref<InstanceType<typeof JuouProForm>>();
const addWeappItems = ref<JuouProFormItem[]>([]);
const addH5FormRef = ref<InstanceType<typeof JuouProForm>>();
const addH5Items = ref<JuouProFormItem[]>([]);
const emit = __emit;
const store = ref<any>({});

const qrcodeDialogVisible = ref(false);

// 获取的二维码值
const qrcodeValues = ref<{
  name: string;
  appid?: string;
  h5TplId?: string;
  url: string;
}[]>([]);


const loading = ref(false);

const saveQrcode = (qrcode: any, inx: any) => {
  const qrcodeEl: any = document.getElementById(`qrcode-${inx}`);
  if (!qrcodeEl) {
    return;
  }
  const dataURL = qrcodeEl.toDataURL('image/png');

  const link = document.createElement('a');
  link.href = dataURL;
  link.download = `qrcode-${qrcode.name}.png`;
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


const init = useBaseAsync(async() => {
  try {
    loading.value = true;
    qrcodeValues.value = [];
    // 获取小程序列表
    const weappRes = await useApi().wxApi.getRelativeWeappwx({ appid: store.value.wxAppid });
    const weappOptions = weappRes?.data?.data?.filter((item: any) => item.status === 1).map((item: any) => ({
      label: item.nickname,
      value: item.appid,
    }));
    // 获取h5模板列表
    const h5TplRes = await useApi().wxTplApi.listWxTplByTenantwxTpl({ });
    const h5TplOptions = h5TplRes?.data?.data?.map((item: any) => ({
      label: `${item.name}(${item.url})`,
      value: item.id,
    }));

    addWeappItems.value = [
      {
        name: 'appid',
        label: '小程序',
        type: 'select',
        rule: [{ required: true }],
        options: weappOptions,
      },
    ];


    addH5Items.value = [
      {
        name: 'id',
        label: 'H5模板',
        type: 'select',
        rule: [{ required: true }],
        options: h5TplOptions,
      },
    ];

    const weappMap = keyBy(weappOptions as any, (item) => String(item.value));
    const res = await useApi().storeApi.getQrcodesstore({
      storeId: store.value.id,
    });
    Object.entries(res?.data?.data?.weappQrcode || {}).forEach(([appid, url]: any) => {
      const weapp = weappMap[appid];
      if (!weapp) {
        return;
      }
      qrcodeValues.value.push({
        name: `${weapp.label}(小程序)`,
        appid,
        url,
      });
    });

    const h5Map = keyBy(h5TplOptions as any, (item) => item.value);
    Object.entries(res?.data?.data?.wxQrcode || {}).forEach(([h5TplId, url]: any) => {
      const h5Tpl = h5Map[String(h5TplId)];
      if (!h5Tpl) {
        return;
      }
      qrcodeValues.value.push({
        name: `${h5Tpl.label}`,
        h5TplId: String(h5TplId),
        url,
      });
    });

    if (res?.data?.data?.directQrcodeUrl) {
      qrcodeValues.value.push({
        name: '直开',
        url: res?.data?.data?.directQrcodeUrl,
      });
    }
    store.value.downloadQrcodeUrl = res.data.data.downloadQrcodeUrl ? res.data.data.downloadQrcodeUrl.split('_#_#_')[0] : '';
  } finally {
    loading.value = false;
  }
});


const setDownloadQrcode = useBaseAsync(async(qrcode: any, inx: any) => {
  const qrcodeEl: any = document.getElementById(`qrcode-${inx}`);
  if (!qrcodeEl) {
    return;
  }
  const dataURL = qrcodeEl.toDataURL('image/png');
  console.log(dataURL);
  try {
    const res = await useApi().uploadApi.imageUpload([convertBase64UrlToImgFile(dataURL, 'qrcode.png').file]);
    console.log(res);

    if (!res.data.data?.[0]) {
      ElMessage.error('设置失败！');
      return;
    }

    await useApi().storeApi.setDownloadQrcodestore({
      storeId: store.value.id,
      qrcodeUrl: `${qrcode.url}_#_#_${res.data.data?.[0]}`,
    });
    init();
    emit('setDownload');
  } catch (error) {
    console.log(error);
  }
});

const handleaddWeappOk = useBaseAsync(async(data: any) => {
  await useApi().storeApi.addWeappQrcodestore({
    storeId: store.value.id,
    appid: data.appid,
  });
  ElMessage.success('添加成功');
  init();
});

const handleaddH5Ok = useBaseAsync(async(data: any) => {
  await useApi().storeApi.addH5Qrcodestore({
    storeId: store.value.id,
    h5TplId: data.id,
  });
  ElMessage.success('添加成功');
  init();
});


const handleAddDirectQrcode = useBaseAsync(async() => {
  await useApi().storeApi.addDirectQrcodeUrlstore({
    storeId: store.value.id,
  });
  ElMessage.success('添加成功');
  init();
});

const delQrcode = useBaseAsync((data: any) => {
  ElMessageBox.confirm('删除后无法恢复，确定要删除吗？', '删除', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
  }).then(async() => {
    if (data.name === '直开') {
      await useApi().storeApi.delDirectQrcodestore({
        storeId: store.value.id,
      });
    } else if (data.name.includes('(小程序)')) {
      await useApi().storeApi.delWeappQrcodestore({
        storeId: store.value.id,
        appid: data.appid,
      });
    } else {
      await useApi().storeApi.delWxQrcodestore({
        storeId: store.value.id,
        h5TplId: data.h5TplId,
      });
    }


    ElMessage.success('删除成功');
    init();
  });
});


__expose({
  show: async(_store: any) => {
    store.value = { ..._store };
    await init();

    qrcodeDialogVisible.value = true;
  },
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: qrcodeDialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((qrcodeDialogVisible).value = $event)),
      title: `${store.value?.name || ''} （一店一码）`,
      width: "900px",
      "z-index": 1000
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = () => addWeappFormRef.value?.showDialog())
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加小程序二维码")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = () => addH5FormRef.value?.showDialog())
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加H5二维码")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = () => _unref(handleAddDirectQrcode)())
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加直开二维码")
              ]),
              _: 1
            })
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: qrcodeValues.value,
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "appid",
                label: "名称",
                width: "180"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(scope.row.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "二维码",
                width: "180"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(QrcodeVue, {
                    id: `qrcode-${scope.$index}`,
                    value: scope.row.url,
                    size: 800,
                    style: {"width":"100px","height":"100px"}
                  }, null, 8, ["id", "value"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "客户端下载" }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(store.value.downloadQrcodeUrl === scope.row.url ? '是': ''), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "",
                width: "380"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: () => saveQrcode(scope.row, scope.$index)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("下载二维码")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: () => _unref(setDownloadQrcode)(scope.row, scope.$index)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("设置客户端下载")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: () => _unref(delQrcode)(scope.row)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, loading.value]
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_unref(JuouProForm), {
      ref_key: "addWeappFormRef",
      ref: addWeappFormRef,
      "is-dialog": "",
      title: "添加小程序二维码",
      items: addWeappItems.value,
      onOk: _unref(handleaddWeappOk)
    }, null, 8, ["items", "onOk"]),
    _createVNode(_unref(JuouProForm), {
      ref_key: "addH5FormRef",
      ref: addH5FormRef,
      "is-dialog": "",
      title: "添加H5二维码",
      items: addH5Items.value,
      onOk: _unref(handleaddH5Ok)
    }, null, 8, ["items", "onOk"])
  ], 64))
}
}

})